"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.setAuthToken = void 0;
var axios_1 = require("axios");
var jwtAxios = axios_1.default.create({
    baseURL: 'https://crema-mongo-api.herokuapp.com/api/',
    headers: {
        'Content-Type': 'application/json',
    },
});
jwtAxios.interceptors.response.use(function (res) { return res; }, function (err) {
    if (err.response && err.response.data.msg === 'Token is not valid') {
        console.log('Need to logout user');
        // store.dispatch({type: LOGOUT});
    }
    return Promise.reject(err);
});
var setAuthToken = function (token) {
    if (token) {
        jwtAxios.defaults.headers.common['x-auth-token'] = token;
        localStorage.setItem('token', token);
    }
    else {
        delete jwtAxios.defaults.headers.common['x-auth-token'];
        localStorage.removeItem('token');
    }
};
exports.setAuthToken = setAuthToken;
exports.default = jwtAxios;
//# sourceMappingURL=jwt-api.js.map